/**
 * @Author : ShaJiaJing
 * @Date : 2019/5/30
 * @Version : 1.0
 * @Content : 接口封装
 */

import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import message from 'ant-design-vue/es/message'

function successParse (res) {
  return new Promise((resolve, reject) => {
    // 返回结果code 为 0 时，表示请求成功，只返回result
    if (res.data.code === 0) {
      resolve(res.data.result)
      // if (res.data.result) {
      //   resolve(res.data.result)
      // } else {
      //   reject(res.data)
      // }
    } else {
      message.error(res.data.msg)
      reject(res.data)
    }
  })
}
function errorParse (err) {
  return new Promise((resolve, reject) => {
    reject(err)
  })
}
function send (url, method, body, options) {
  // 生成请求的url
  // url = !url.startsWith('http') ? `${DOMAIN}${url}` : url
  const opts = { ...options }
  const USERINFO = JSON.parse(store.getters.userInfo || '{}')
  opts.headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    ...opts.headers
  }
  if (USERINFO.tenantNo) {
    opts.headers.tenantNo = USERINFO.tenantNo
  }
  // opts.headers.tenantNo = 'c01413b3cf5541278f676df26aebda43'
  // post form-data请求将参数序列化成 form 参数
  if (options && options.isForm) {
    body = qs.stringify(body)
  }
  if ((body && method === 'get') || (body && method === 'delete')) {
    opts.params = body
  }
  switch (method) {
    case 'get':
      return axios.get(url, opts)
        .then((res) => successParse(res))
        .catch((ex) => errorParse(ex && ex.response))
    case 'post':
      return axios.post(url, body, opts)
        .then((res) => successParse(res))
        .catch((ex) => errorParse(ex))
    case 'put':
      return axios.put(url, body, opts)
        .then((res) => successParse(res))
        .catch((ex) => errorParse(ex))
    case 'delete':
      return axios.delete(url, opts)
        .then((res) => successParse(res))
        .catch((ex) => errorParse(ex))
  }
}
class BaseApi {
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  };
  /**
   * @param url 请求链接
   * @param body 入参
   * @param options header 头信息
   * @param defData 是否只返回出参 data 内容
   * @returns {Promise<U>|*|Promise|Promise<T>}
   */
  get (url, body, options) {
    return send(this.baseUrl + url, 'get', body, options)
  };
  delete (url, body, options) {
    return send(this.baseUrl + url, 'delete', body, options)
  };
  post (url, body, options) {
    return send(this.baseUrl + url, 'post', body, options)
  };
  put (url, body, options) {
    // console.log(body, '-----------------------------------')
    return send(this.baseUrl + url, 'put', body, options)
  };
}

export default BaseApi
